<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let filled = false;
  export let hover = false;
  export let readOnly;

  const dispatch = createEventDispatcher();
</script>

<svg
  class:readOnly
  on:mouseover={() => dispatch('mouseover')}
  on:click
  on:focus={() => {}}
  width="24"
  height="24"
  viewBox="0 0 48 48"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    class:filled
    class:hover
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M30.1967 16.7469L25.6019 6.97299C25.4333 6.67815 25.2084 6.44225 24.9274 6.26535C24.6464 6.08845 24.3372 6 24 6C23.6628 6 23.3536 6.08845 23.0726 6.26535C22.7916 6.44225 22.5667 6.67815 22.3981 6.97299L17.8033 16.7469L7.55972 18.2949C7.11007 18.3538 6.73068 18.5602 6.42155 18.914C6.14052 19.2678 6 19.6806 6 20.1523C6 20.4177 6.04215 20.6683 6.12646 20.9042C6.23888 21.14 6.37939 21.3464 6.54801 21.5233L13.9672 29.086L12.2389 39.7887C12.2108 39.8477 12.1967 39.9066 12.1967 39.9656V40.1425C12.1967 40.6437 12.3653 41.086 12.7026 41.4693C13.0679 41.8231 13.5035 42 14.0094 42C14.1499 42 14.2904 41.9853 14.4309 41.9558C14.5714 41.9263 14.7119 41.8673 14.8525 41.7789L24 36.7371L33.1475 41.7789C33.2881 41.8673 33.4286 41.9263 33.5691 41.9558C33.7096 41.9853 33.8501 42 33.9906 42C34.4965 42 34.918 41.8231 35.2553 41.4693C35.6206 41.086 35.8033 40.6437 35.8033 40.1425V39.9656C35.8033 39.9066 35.7892 39.8477 35.7611 39.7887L34.0328 29.086L41.452 21.5233C41.6206 21.3464 41.7471 21.14 41.8314 20.9042C41.8464 20.8726 41.8605 20.8407 41.8735 20.8086C41.889 20.7705 41.9031 20.732 41.9157 20.6931C41.9719 20.5203 42 20.34 42 20.1523C42 20.0639 41.9859 19.9754 41.9578 19.887C41.9578 19.8036 41.9438 19.7276 41.9157 19.6589C41.9058 19.6349 41.8943 19.6117 41.881 19.5894C41.8785 19.5854 41.8761 19.5814 41.8735 19.5774H41.9157C41.9132 19.5701 41.9106 19.5628 41.908 19.5555C41.8972 19.5257 41.8857 19.4963 41.8735 19.4672C41.7569 19.1892 41.5742 18.9459 41.3255 18.7371C41.0726 18.5012 40.7775 18.3538 40.4403 18.2949L30.1967 16.7469Z"
    fill="transparent"
    stroke="#047AC2"
    stroke-width="2"
  />
</svg>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  svg {
    outline: none;
    cursor: pointer;

    &.readOnly {
      cursor: default;
    }
    path {
      &.filled {
        fill: $primary-yellow;
      }

      &.hover:not(.filled) {
        fill: adjust-color($color: $primary-yellow, $alpha: -0.7);
      }
    }
  }
</style>
